// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_12n6USYYj2__RxK9ZTVW1H"};